import * as React from 'react';
import Label from '../Label';
import { cn } from '../../../../utils/styles';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export interface ITextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  variant?: 'default' | 'transparent' | 'white';
  error?: string | null;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, ITextareaProps>(
  ({ className, name, label, error, variant, ...props }, ref) => (
    <div className={cn(className)}>
      {label ? (
        <Label htmlFor={name} className={cn({ '!text-destructive': error })}>
          {label}
        </Label>
      ) : null}
      <textarea
        className={cn(
          'flex min-h-[60px] w-full rounded-md border border-input px-3 py-2 text-sm ' +
            'shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 ' +
            'focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 bg-inputBg',
          {
            '!bg-transparent': variant === 'transparent',
            '!bg-white': variant === 'white',
            '!border-destructive focus-visible:!ring-destructive': error,
          },
        )}
        ref={ref}
        {...props}
      />
    </div>
  ),
);

Textarea.defaultProps = {
  label: '',
  error: null,
  variant: 'default',
};

Textarea.displayName = 'Textarea';

export { Textarea };
